export default {
  listExecutivePositions: [],
  executivePosition: {
    nome: '',
    ativo: true,
  },
}
